// Eskom PARCC — map a per-mechanism working-paper template's canonical
// mechanism to the nearest CES route (the 8-route classifier label). Shared by
// the CES capture page and the workbook upload (R5 #1): the criteria shown /
// captured come from the template or the uploaded sheet; the route is the
// classifier hint `buildCesCapture` records.
import type { CesRoute } from '../../domain/enums';

const TEMPLATE_ROUTE: Record<string, CesRoute> = {
  'Formal Tendering - Contracts': 'Formal Tendering - Contracts',
  'Informal Tendering - Contracts': 'Formal Tendering - Contracts',
  "Informal Tendering - PO's": "Informal Tendering - PO's",
  LPO: 'LPO',
  Emergency: 'Emergency',
  Urgent: 'Urgent',
  'Sole Source': 'Sole Source',
  'Single Source': 'Single Source',
  'Expansions - Modifications': 'Expansions - Modifications',
  'Task Order': 'Formal Tendering - Contracts',
  Transversal: 'Formal Tendering - Contracts',
  'Multiple Sources': 'Formal Tendering - Contracts',
};

export function templateToCesRoute(mechanism: string): CesRoute {
  return TEMPLATE_ROUTE[mechanism] ?? 'Formal Tendering - Contracts';
}
